/**
 * Onboarding gate helpers — A/B-testable new-user funnel.
 *
 * The backend is the source of truth: it computes the gate in
 * profile_status.onboarding_gate (login / auto-login responses) and in the
 * top-level onboarding_gate field of GET /auth/profile (merged into `user`),
 * and ENFORCES it on the chat endpoint. Everything here only drives UI.
 *
 * A missing/null gate means "legacy behavior": landing page shown,
 * verify-before-chat, admin approval required.
 *
 * Backend plan: concierge-fast-api/docs/plans/ONBOARDING_GATE_AB_FLOW_PLAN.md
 */

export const GATE_NOTICE =
  'For security purposes, please verify your phone number to continue using the chat.';

/** Resolve the gate object from wherever the backend put it. */
export function getOnboardingGate(user, profileStatus = null) {
  return profileStatus?.onboarding_gate || user?.onboarding_gate || null;
}

/** false ONLY when the backend explicitly disabled the landing page. */
export function landingPageEnabled(gate) {
  return gate ? gate.show_landing_page !== false : true;
}

/** false ONLY when the backend explicitly disabled admin approval. */
export function approvalRequired(gate) {
  return gate ? gate.require_admin_approval !== false : true;
}

/** Deferred mode: user may chat for N free messages before verifying. */
export function verificationDeferred(gate) {
  return !!gate && gate.free_message_limit > 0;
}

/** The backend says the free window is used up — verification is due NOW. */
export function verificationRequiredNow(gate) {
  return gate?.verification_required === true;
}
